export enum BusinessType {
  HasHandelsregister = 'has_handelsregister',
  SoleTrader = 'sole_trader',
}

export interface RegistryAddress {
  street: string;
  city: string;
  postalCode: string;
  countryCode: string;
}

export interface HqAddress {
  street: string;
  city: string;
  postalCode: string;
  countryId: number;
  countryIsoCode: string;
}

export interface RegistrySearchResult {
  id: string;
  companyName: string;
  registryNumber: string;
  registryCourt: string;
  hqAddress?: RegistryAddress;
}

export interface GermanBiSubmitPayload {
  type: BusinessType;
  registryNumber?: string;
  soleTraderNumber?: string;
  hqAddress?: HqAddress;
}

export interface BusinessTypeOption {
  value: BusinessType;
  label: string;
}
